import { createFileRoute } from '@tanstack/react-router';
import { ImmobilisationsPage } from '@/features/immobilisations/components/ImmobilisationsPage';

export const Route = createFileRoute('/$commiteeSlug/immobilisations/{-$id}')({
  component: ImmobilisationsPage,
});
